// removed by extract-text-webpack-plugin
module.exports = {"CustomIcon":"Archive__CustomIcon__q5rIe"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Archive.css
// module id = 1696
// module chunks = 2